var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_27555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9297 7.58155C11.8143 7.25692 11.6013 6.97589 11.32 6.77694C11.0387 6.57798 10.7028 6.47082 10.3583 6.47012H9.06829C8.70026 6.46819 8.34459 6.6028 8.07006 6.84791C7.79553 7.09302 7.62163 7.43122 7.58201 7.79712C7.54238 8.16301 7.63983 8.5306 7.85552 8.8288C8.07121 9.127 8.38981 9.33464 8.74972 9.41155L10.714 9.84012C11.1157 9.92805 11.4706 10.1613 11.7108 10.4951C11.9509 10.8288 12.0592 11.2395 12.0149 11.6483C11.9706 12.0571 11.7768 12.435 11.4708 12.7096C11.1647 12.9842 10.768 13.136 10.3569 13.1358H9.24686C8.52115 13.1358 7.904 12.673 7.67543 12.0258M9.80257 6.47012V4.80298M9.80257 14.803V13.1373M2.854 19.283V15.7116H6.42543",
    stroke: "#00ADEF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1255 8.29153C19.5047 10.3133 19.2019 12.4037 18.2646 14.2347C17.3273 16.0658 15.8086 17.5338 13.9467 18.4083C12.0849 19.2828 9.98538 19.5144 7.9777 19.0666C5.97003 18.6189 4.16786 17.5171 2.85404 15.9344M0.874043 11.7087C0.494793 9.68694 0.797581 7.59651 1.73488 5.76547C2.67219 3.93444 4.19095 2.46646 6.05278 1.59193C7.91462 0.717407 10.0141 0.485848 12.0218 0.933599C14.0295 1.38135 15.8317 2.48306 17.1455 4.06582",
    stroke: "#00ADEF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1456 0.716797V4.28823H13.5742",
    stroke: "#00ADEF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_27555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.548e258b0dc95222bbde6f9bfd290727.svg";
export { ForwardRef as ReactComponent };